import { render, staticRenderFns } from "./CategoriesSidebarV2.vue?vue&type=template&id=2bdd9124&scoped=true"
import script from "./CategoriesSidebarV2.vue?vue&type=script&lang=js"
export * from "./CategoriesSidebarV2.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSidebarV2.vue?vue&type=style&index=0&id=2bdd9124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd9124",
  null
  
)

export default component.exports